export default {"src":"/_next/static/media/ic-line-check.ec500aa4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};